// extracted by mini-css-extract-plugin
export var link = "_tv-0";